// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Security'"></sub-header>

<div class="tab-menu">
  <ul class="nav-tabs">
    <li class="active"><a data-target="#tab_general" data-toggle="tab">
      <span>General</span>
    </a>
    </li>
    <li><a data-target="#tab_machine_specific" data-toggle="tab">
      <span>Machine specific</span>
    </a>
    </li>
    <li><a data-target="#tab_roles" data-toggle="tab">
      <span>User Roles</span>
    </a></li>
  </ul>
</div>

<div class="tab-content" style="overflow: unset">
  <div class="tab-pane active" id="tab_general" >
    <security-general></security-general>
  </div>
  <div class="tab-pane" id="tab_machine_specific" >
    <security-machine-specific></security-machine-specific>
  </div>
  <div class="tab-pane" id="tab_roles" >
    <roles-list roles="\$ctrl.roles">
    </roles-list>
  </div>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/security.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;